import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BreakdownCategory, BreakdownCode, CodePanne } from 'src/app/model/breakdowns/breakdown';
import { WebConfigurationService } from '../common/web-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class BreakdownsService extends WebConfigurationService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  /**
  * GET the 'Breakdowns category' datas
  * @returns an Observable
  */
  public breakdownsCategoryList() {
    return this.authGetObs<BreakdownCategory[]>(this.getCategoriesPannesUrl());
  }

  /**
 * POST a category breakdown
 * @returns  an Observable
 */
  public postBreakdownCategory(newCategory: BreakdownCategory): Observable<any> {
    return this.http.post<BreakdownCategory>(this.getCategoriesPannesUrl(), newCategory, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }


  /**
   * UPDATE a category breakdown
   * @param id
   * @param body
   * @returns
   */
  public editBreakdownCategory(id : number, body : BreakdownCategory) {
    let url = this.getCategoriesPannesUrl() + '/update/' + id;
    return this.authPutObs<BreakdownCategory>(url, body);
  }


  /**
 * DELETE a category breakdown.
 * @param id  a valid category ID.
 */
  public deleteBreakdownCategory(id: string, body : BreakdownCategory) {
    let url = this.getCategoriesPannesUrl() + '/delete/' + id;
    return this.authPutObs<BreakdownCategory>(url, body);
  }



  /**
  * GET the 'Breakdowns codes' datas
  * @returns an Observable
  */
  public breakdownsCodesList() {
    return this.authGetObs<BreakdownCode[]>(this.getCodesPannesUrl());
  }



  /**
   * GET the list from codes_pannes table
   */
  public getCodesPannesData() {
    return this.authGetObs<CodePanne[]>(this.getCodesPannesTableUrl());
  }


  /**
* POST a code panne
* @returns  an Observable
*/
  public postPanneCode(newPanneCode: CodePanne): Observable<any> {
    return this.http.post<BreakdownCode>(this.getCodesPannesTableUrl(), newPanneCode, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }


  public editPanneCode(catId : number, codeId: number, body : CodePanne) {
    let url = this.getCodesPannesTableUrl() + '/update/' + + catId + '&' + codeId;
    return this.authPutObs<CodePanne>(url, body);
  }

  /**
   * DELETE a code panne
   */
  public deleteCodePanne(catId: number, codeId: number, body: CodePanne) {
    let url = this.getCodesPannesTableUrl() + '/delete/' + catId + '&' + codeId;
    return this.authPutObs<CodePanne>(url, body);
  }

  public getAdpsBreakdownList(startDate: Date, endDate: Date, serialNumber: string, subject: string, groupMode: string, beginServiceDate : Date, endServiceDate : Date, breakdownCode : string): Observable<any> {
    let sDate = this.getFormattedDate(startDate);
    let eDate = this.getFormattedDate(endDate);

    let serviceSDate = this.getFormattedDate(beginServiceDate)
    let serviceEDate = this.getFormattedDate(endServiceDate)

    return this.authGetObs<any>(this.getAdpsBreakdownUrl(sDate,eDate,serialNumber,subject,groupMode,serviceSDate,serviceEDate,breakdownCode));
  }


   /**
  * GET the Breakdowns datas for one year
  * @returns an Observable
  */
    public breakdownsOneYear() {
      return this.authGetObs<any[]>(this.getbreakdownsOneYearUrl());
    }


     /**
   * GET breakdown solver by day by person
   */
  public getBreakdownSolverData() {
    return this.authGetObs<any[]>(this.getBreakdownSolverDataUrl());
  }
     /**
   * GET breakdown solver by day by person
   */
  public getAllBreakdownSolver() {
    return this.authGetObs<any[]>(this.getBreakdownAllBreakdownSolverUrl());
  }
     /**
   * GET breakdown solver by day by person
   */
  public getBreakdownSavById(id : string) {
    return this.authGetObs<any[]>(this.getBreakdownDetailByIdUrl(id));
  }

}
